"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var Immutable = require("seamless-immutable");
var typescript_fsa_1 = require("typescript-fsa");
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var notification = require("../infra/notification");
var utils_1 = require("./utils");
var actionCreator = typescript_fsa_1.default("SETTINGS");
var checkNotificationPermission = actionCreator("CHECK_NOTIFICATION_PERMISSION");
var requestNotificationPermission = actionCreator("REQUEST_NOTIFICATION_PERMISSION");
var setAlarmVolume = actionCreator("SET_ALARM_VOLUME");
var setNotificationState = actionCreator("SET_NOTIFICATION_STATE");
exports.actionCreators = {
    checkNotificationPermission: checkNotificationPermission,
    requestNotificationPermission: requestNotificationPermission,
    setAlarmVolume: setAlarmVolume,
    setNotificationState: setNotificationState,
};
exports.initialState = Immutable({ alarmVolume: 0.5, notificationOn: null });
exports.reducer = typescript_fsa_reducers_1.reducerWithInitialState(exports.initialState)
    .case(setAlarmVolume, function (state, alarmVolume) { return state.merge({ alarmVolume: alarmVolume }); })
    .case(setNotificationState, function (state, notificationOn) { return state.merge({ notificationOn: notificationOn }); });
exports.sagas = [
    utils_1.takeEvery(checkNotificationPermission, function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.put(setNotificationState(notification.permission()))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }),
    utils_1.takeEvery(requestNotificationPermission, function _() {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = effects_1.put;
                    _b = setNotificationState;
                    return [4 /*yield*/, effects_1.call(notification.requestPermission)];
                case 1: return [4 /*yield*/, _a.apply(void 0, [_b.apply(void 0, [_c.sent()])])];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }),
];
exports.persistent = true;



//////////////////
// WEBPACK FOOTER
// ./src/redux/settings.ts
// module id = 101
// module chunks = 0